import { css } from '@emotion/react'

const fullWidth = css`
  max-width: 100%;
`

export const styles = {
  fullWidth,
}
